import { Stack, StackProps } from '@mantine/core';
import { forwardRef } from 'react';

export type IStackProps = StackProps;

export const ZorroStack = forwardRef<HTMLDivElement, IStackProps>(
  ({ ...props }: IStackProps, ref) => {
    return <Stack ref={ref} {...props} />;
  }
);
